// Define the different namespaces for the logger
export type LogNamespaceRootKeyType = "root";

// adhoc namespace is used for temporary debugging. All call to log stuff using adhoc namespace should be removed before making a PR.
export type LogNamespaceAdhocKeyType = "adhoc";

export type LogNamespaceDeviceKeyType = "device" |
  "deviceScreen" |
  "deviceKeyboard" |
  "storage" |
  "storageLocal" |
  "storageSession";

export type LogNamespaceMicrophoneKeyType = "microphone";

export type LogNamespaceRouterKeyType = "router" |
  "routerMatch" |
  "routerCustomMatch";

export type LogNamespaceLessonPlayerKeyType = "lesson" |
  "lessonAudio" |
  "lessonScorer" |
  "lessonScorerNote" |
  "lessonScorerPerformance" |
  "lessonScorerVideo" |
  "lessonSettings" |
  "noteScorerWorker";

export type LogNamespaceMetronomeType = "metronome";

export type LogNamespaceMidiKeyType =
  "midi" |
  "midiAction" |
  "midiAccess" | // Used to track stuff that happens around requesting MIDI access
  "midiConnectionEvent" | // Used to track stuff around plugging in / unplugging a MIDI device
  "midiEventBus" |
  "midiInputs" | // Used to track stuff that happens with the MIDI inputs
  "midiNoteAction" |
  "midiSubscription";

export type LogNamespaceNoteType = "note";

export type LogNamespaceApiKeyType = "api";

export type LogNamespaceVendorKeyType = "vendor" |
  "vendorSoundSlice" |
  "vendorSoundSliceMessage" |
  "vendorSoundSliceMessageSend";

export type LogNamespaceUserKeyType = "user" |
  "userAction" |
  "userAuth" |
  "userNavigation";

export type LogNamespaceOnboardingKeyType = "onboarding";

export type LogNamespacePitchDetectionType =
  "pitchDetection";

export type LogNamespaceBridgeMessagesKeyType =
  "nativeToWebviewMessage" |
  "webviewToNativeMessage";

// New namespaces should be added above this line then included as part of LogNamespaceKeyType

// Aggregate the namespaces above into a single type. This will register the namespaces with the logger.
export type LogNamespaceKeyType = "core" |
  LogNamespaceAdhocKeyType |
  LogNamespaceApiKeyType |
  LogNamespaceBridgeMessagesKeyType |
  LogNamespaceDeviceKeyType |
  LogNamespaceLessonPlayerKeyType |
  LogNamespaceMetronomeType |
  LogNamespaceMicrophoneKeyType |
  LogNamespaceMidiKeyType |
  LogNamespaceNoteType |
  LogNamespaceOnboardingKeyType |
  LogNamespacePitchDetectionType |
  LogNamespaceRootKeyType |
  LogNamespaceRouterKeyType |
  LogNamespaceUserKeyType |
  LogNamespaceVendorKeyType;

export type LogNamespaceType = `pg` | `pg:${string}`;

// Define log prefixes for the different namespaces - these prefixes will show up in the console.
export const loggerNamespaces: Record<LogNamespaceKeyType, LogNamespaceType> = {
  adhoc: `pg:adhoc`,
  api: `pg:api`,
  core: `pg:core`,
  device: `pg:device`,
  deviceKeyboard: `pg:device:keyboard`,
  deviceScreen: `pg:device:screen`,
  lesson: `pg:lesson`,
  lessonAudio: `pg:lesson:audio`,
  lessonScorer: `pg:lesson:scorer`,
  lessonScorerNote: `pg:lesson:scorer:note`,
  lessonScorerPerformance: `pg:lesson:scorer:performance`,
  lessonScorerVideo: `pg:lesson:scorer:video`,
  lessonSettings: `pg:lesson:settings`,
  midi: `pg:midi`,
  midiAccess: 'pg:midiAccess',
  midiAction: `pg:midi:action`,
  midiConnectionEvent: 'pg:midiConnectionEvent',
  midiEventBus: 'pg:midiEventBus',
  midiInputs: 'pg:midiInputs',
  midiNoteAction: 'pg:midiNoteAction',
  midiSubscription: 'pg:midiSubscription',
  metronome: `pg:metronome`,
  microphone: `pg:microphone`,
  noteScorerWorker: 'pg:noteScorerWorker',
  nativeToWebviewMessage: 'pg:nativeToWebviewMessage',
  note: `pg:note`,
  onboarding: `pg:onboarding`,
  pitchDetection: `pg:pitchDetection`,
  root: `pg`,
  router: `pg:router`,
  routerCustomMatch: `pg:router:custom:match`,
  routerMatch: `pg:router:match`,
  storage: `pg:storage`,
  storageLocal: `pg:storage:local`,
  storageSession: `pg:storage:session`,
  user: `pg:user`,
  userAction: `pg:user:action`,
  userAuth: `pg:user:auth`,
  userNavigation: `pg:user:nav`,
  vendor: `pg:vendor`,
  vendorSoundSlice: `pg:vendor:soundSlice`,
  vendorSoundSliceMessage: `pg:vendor:soundSlice:message`,
  vendorSoundSliceMessageSend: `pg:vendor:soundSlice:message:send`,
  webviewToNativeMessage: 'pg:webviewToNativeMessage',
};

export const loggerConfig = {
  namespaces: loggerNamespaces
};
